// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DateFns = require("date-fns");
let Stdlib_JsExn = require("@rescript/runtime/lib/js/Stdlib_JsExn.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let Primitive_exceptions = require("@rescript/runtime/lib/js/Primitive_exceptions.js");

function isInvalidDate(d) {
  return Number.isNaN(d.getTime());
}

function parse(date, format, reference) {
  let tmp;
  try {
    tmp = {
      TAG: "Ok",
      _0: DateFns.parse(date, format, reference)
    };
  } catch (raw_e) {
    let e = Primitive_exceptions.internalToException(raw_e);
    if (e.RE_EXN_ID === "JsExn") {
      let e$1 = e._1;
      let name = Stdlib_Option.getOr(Stdlib_JsExn.name(e$1), "Nameless JS exn");
      let message = Stdlib_Option.getOr(Stdlib_JsExn.message(e$1), "Empty message");
      tmp = {
        TAG: "Error",
        _0: name + (": " + message)
      };
    } else {
      throw e;
    }
  }
  return Stdlib_Result.flatMap(tmp, d => {
    if (Number.isNaN(d.getTime())) {
      return {
        TAG: "Error",
        _0: "Invalid date"
      };
    } else {
      return {
        TAG: "Ok",
        _0: d
      };
    }
  });
}

function formatISO(date, representation, param) {
  return DateFns.formatISO(date, {
    representation: representation
  });
}

exports.isInvalidDate = isInvalidDate;
exports.parse = parse;
exports.formatISO = formatISO;
/* date-fns Not a pure module */
